import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import AttendanceDurationAPI from '../../api/attendanceDuration/api-attendance-duration';

export const fetchAttendanceDurations = createAsyncThunk(
  'attendanceDuration/fetchAttendanceDurations',
  async (_, thunkAPI) => {
    try {
      const response = await AttendanceDurationAPI.getAll();
      return response?.data?.data ?? [];
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const addAttendanceDuration = createAsyncThunk(
  'attendanceDuration/addAttendanceDuration',
  async (payload, thunkAPI) => {
    try {
      const response = await AttendanceDurationAPI.add(payload);
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const updateAttendanceDuration = createAsyncThunk(
  'attendanceDuration/updateAttendanceDuration',
  async (payload, thunkAPI) => {
    try {
      const response = await AttendanceDurationAPI.update(payload.id, payload);
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const deleteAttendanceDuration = createAsyncThunk(
  'attendanceDuration/deleteAttendanceDuration',
  async (id, thunkAPI) => {
    try {
      const res = await AttendanceDurationAPI.delete(id);
      console.log('res>>>', res);

      return res?.data?.deletedIds ?? id; // return actual deleted IDs
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const initialState = {
  list: [],
  loading: false,
  error: '',
};

const attendanceDurationSlice = createSlice({
  name: 'attendanceDuration',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAttendanceDurations.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(fetchAttendanceDurations.fulfilled, (state, action) => {
        state.loading = false;
        state.list = [...action.payload];
      })
      .addCase(fetchAttendanceDurations.rejected, (state, action) => {
        state.loading = false;
        state.list = [];
        state.error = action.payload ?? 'An error occurred';
      })
      .addCase(addAttendanceDuration.fulfilled, (state, action) => {
        state.list.push(action.payload);
      })
      .addCase(updateAttendanceDuration.fulfilled, (state, action) => {
        const index = state.list.findIndex(
          (item) => item.id === action.payload.id
        );
        if (index !== -1) {
          state.list[index] = action.payload;
        }
      })

      .addCase(deleteAttendanceDuration.fulfilled, (state, action) => {
       
        if (Array.isArray(action.payload)) {
          state.list = state.list.filter(
            (item) => !action.payload.includes(item.id)
          );
        } else {
          state.list = state.list.filter((item) => item.id !== action.payload);
        }
      });
  },
});

export default attendanceDurationSlice.reducer;
